import React from 'react';

export const prop = 'countryName';

export const config = (labels) => ({
	id: 'geographyColumn',
	label: labels.geography,
	propName: prop,
	width: 'minmax(var(--px-150), 1fr)',
	sortBy: prop
});
